import { ArrowStyleType } from '../../../../view-data/shared/line/general/arrow-style-type';
var PolyLineGeneralGoModelToDataConverter = /** @class */ (function () {
    function PolyLineGeneralGoModelToDataConverter(data) {
        this._stroke = data.stroke;
        this._strokeWidth = data.strokeWidth;
        this._lineType = data.lineType;
        this._arrow = {
            isArrow: data.isArrow ? data.isArrow : false,
            arrowStyle: data.arrowStyle ? data.arrowStyle : ArrowStyleType.CommonLeft
        };
    }
    Object.defineProperty(PolyLineGeneralGoModelToDataConverter.prototype, "stroke", {
        get: function () {
            return this._stroke;
        },
        set: function (v) {
            this._stroke = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolyLineGeneralGoModelToDataConverter.prototype, "strokeWidth", {
        get: function () {
            return this._strokeWidth;
        },
        set: function (v) {
            this._strokeWidth = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolyLineGeneralGoModelToDataConverter.prototype, "lineType", {
        get: function () {
            return this._lineType;
        },
        set: function (v) {
            this._lineType = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PolyLineGeneralGoModelToDataConverter.prototype, "arrow", {
        get: function () {
            return this._arrow;
        },
        set: function (v) {
            this._arrow = v;
        },
        enumerable: true,
        configurable: true
    });
    return PolyLineGeneralGoModelToDataConverter;
}());
export { PolyLineGeneralGoModelToDataConverter };
